// Methods
export const HTTP_METHOD_GET = 'GET';
export const HTTP_METHOD_DELETE = 'DELETE';
export const HTTP_METHOD_POST = 'POST';
export const HTTP_METHOD_PUT = 'PUT';
export const HTTP_METHOD_PATCH = 'PATCH';

// ContentTypes
export const CONTENT_TYPE_JSON = 'application/json';
